import {
  createUser,
  fetchUsers,
  setInviteUsersPanelVisibleStatus,
  setEditUserRolePanelVisibleStatus,
  setUserProfileVisibleStatus,
  setEditUserInfoPanelVisibleStatus,
  setDeactivateUserModelVisibleStatus,
  setReactivateUserModelVisibleStatus,
  setResendInvitationModelVisibleStatus,
  setRevokeInvitationModelVisibleStatus,
  setDisableMFAModelVisibleStatus,
  updateUser,
  updateUserStatus,
  resendUserInvitation,
  disableUserMFA,
} from '../routines';

const initialState = {
  isLoading: false,
  isSuccess: false,
  allUsers: [],
  activeUsers: [],
  invitedUsers: [],
  deactivatedUsers: [],
  isInviteUsersPanelVisible: false,
  isEditUserRolePanelVisible: false,
  isUserProfilePanelVisible: false,
  isEditUserInfoPanelVisible: false,
  isDeactivateUserModelVisible: false,
  isReactivateUserModelVisible: false,
  isResendInvitationModelVisible: false,
  isRevokeInvitationModelVisible: false,
  istDisableMFAModelVisible: false,
  selectedUser: {},
};

const userReducer = (state = initialState, action) => {
  switch (action.type) {
    case createUser.TRIGGER:
    case fetchUsers.TRIGGER:
    case updateUser.TRIGGER:
    case updateUserStatus.TRIGGER:
    case resendUserInvitation.TRIGGER:
    case disableUserMFA.TRIGGER:
      return {
        ...state,
        isLoading: true,
      };
    case updateUser.SUCCESS:
    case createUser.SUCCESS:
    case updateUserStatus.SUCCESS:
    case resendUserInvitation.SUCCESS:
    case disableUserMFA.SUCCESS:
      return {
        ...state,
        isSuccess: true,
        isLoading: false,
        ...action.payload?.stateControlData,
      };
    case fetchUsers.SUCCESS:
      return {
        ...state,
        allUsers: [
          ...action.payload.activeUsers,
          ...action.payload.invitedUsers,
          ...action.payload.deactivatedUsers,
        ],
        activeUsers: action.payload.activeUsers,
        invitedUsers: action.payload.invitedUsers,
        deactivatedUsers: action.payload.deactivatedUsers,
        isSuccess: true,
        isLoading: false,
      };

    case createUser.FAILURE:
    case fetchUsers.FAILURE:
    case updateUser.FAILURE:
    case updateUserStatus.FAILURE:
    case disableUserMFA.FAILURE:
      return {
        ...state,
        isLoading: false,
        isSuccess: false,
      };

    case setInviteUsersPanelVisibleStatus.TRIGGER:
      return {
        ...state,
        isInviteUsersPanelVisible: action.payload.isVisible,
      };

    case setEditUserRolePanelVisibleStatus.TRIGGER:
      return {
        ...state,
        isEditUserRolePanelVisible: action.payload.isVisible,
        selectedUser: action.payload.user || {},
      };
    case setUserProfileVisibleStatus.TRIGGER:
      return {
        ...state,
        isUserProfilePanelVisible: action.payload.isVisible,
        selectedUser: action.payload.user || {},
      };
    case setEditUserInfoPanelVisibleStatus.TRIGGER:
      return {
        ...state,
        isEditUserInfoPanelVisible: action.payload.isVisible,
        selectedUser: action.payload.user || {},
      };
    case setDeactivateUserModelVisibleStatus.TRIGGER:
      return {
        ...state,
        isDeactivateUserModelVisible: action.payload.isVisible,
        selectedUser: action.payload.user || {},
      };
    case setReactivateUserModelVisibleStatus.TRIGGER:
      return {
        ...state,
        isReactivateUserModelVisible: action.payload.isVisible,
        selectedUser: action.payload.user || {},
      };
    case setResendInvitationModelVisibleStatus.TRIGGER:
      return {
        ...state,
        isResendInvitationModelVisible: action.payload.isVisible,
        selectedUser: action.payload.user || {},
      };
    case setRevokeInvitationModelVisibleStatus.TRIGGER:
      return {
        ...state,
        isRevokeInvitationModelVisible: action.payload.isVisible,
        selectedUser: action.payload.user || {},
      };
    case setDisableMFAModelVisibleStatus.TRIGGER:
      return {
        ...state,
        istDisableMFAModelVisible: action.payload.isVisible,
        selectedUser: action.payload.user || {},
      };

    default:
      return state;
  }
};

export default userReducer;
